module.exports = __webpack_public_path__ + "assets/img/Multivariate_Gaussian.f5f5e662.png";